<template>
<m-pageframe
    title="{organization_label} Events"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
        append-icon="mdi-refresh"
        v-on:click:append="doUpdate"
    >
    </v-text-field>

    <m-edit-multi-select
         v-model="type"
         label="Event Type"
         :items="$rc.enumChoices('event_type',true)"
         v-on:input="doUpdate"
         no_item_text="No event types selected"
    />

    <v-chip
       color="secondary"
       label
       dense
       class="button_chip"
       v-on:click="type = ['any_enum_value']; doUpdate();"
    >
        All Events
    </v-chip>

    <v-chip
       color="secondary"
       label
       dense
       class="button_chip"
       v-on:click="onClickOrders"
    >
        Orders
    </v-chip>

    <v-chip
       color="secondary"
       label
       dense
       class="button_chip"
       v-on:click="onClickReservations"
    >
        Reservations
    </v-chip>

    

    <v-chip
       color="secondary"
       label
       dense
       class="button_chip"
       v-on:click="onClickSecondGenerationShippingEvents"
    >
        Second Generation Shipping Events
    </v-chip>

    

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :loading="loading"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        v-on:click:row="onClickEventDetails"
    >
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.object_number="{ item }">
            {{item.subject_order_number ?? item.subject_reservation_number}} 
        </template>


        <template v-slot:item.endpoints="{ item }">
            <div
                v-for="(number, index) in item.endpoints"
                :key="index"
            >
                    {{$rc.pretty(number,'endpoint')}}
            </div>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEventDetails(item)"
                >
                    <v-list-item-title>View Event Details...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickMessageParameters(item)"
                >
                    <v-list-item-title>Message Parameters...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalData(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-log-view-dialog
        ref="event-log-entries"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            full_text: null,
            type: ['any_enum_value'],
            loading: false,

            results: [],

            headers: [
                { text: 'Triggered By', value: 'content_type'},
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'Type', value: 'type'},
                { text: 'Number', value: 'object_number'},


                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { 'text' : 'Phone', 'value' : 'endpoints' },
                { 'text' : 'Tracking No', 'value' : 'subject_shipment_tracking_number' },


                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        if ( this.$route.query['event-contains'] != null )
        {
            let substr = this.$route.query['event-contains'];
            
            let type_choices = this.$rc.enumChoices('event_type',true);

            this.type = [];

            for ( let i = 0; i < type_choices.length; i++ )
            {
                if ( type_choices[i].value.includes(substr) )
                {
                    if ( substr == 'wine-direct-fulfillment' && type_choices[i].value == 'wine-direct-fulfillment-not-supported' ) continue;
                    if ( substr == 'wine-direct-fulfillment' && type_choices[i].value == 'wine-direct-fulfillment-unknown' ) continue;

                    this.type.push(type_choices[i].value);
                }
            }
        }

        if ( this.$route.query['initial-event-types'] == 'second-generation-shipping-events' )
        {
            this.type = [
                "shipping-new-tracking-number",
                "shipping-first-in-transit",
                "shipping-in-transit",
                "out-for-delivery",
                "delivery-attempt-failed",
                "available-for-pickup", 
                "picked-up",
                "delivered",
                "exception",
                "not-supported",
            ];
        }

        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            let type = this.type.includes('any_enum_value') ? null : this.type;

            this.loading = true;

            this.$rc.rest(
                'LIST: /api/v1/events',
            
                {
                    'full_text': this.full_text,
                    'organization_id': this.$route.params.organization_id,
                    'type': type,
                    'contact_request_inbox_id': this.$route.query.contact_request_inbox_id,
                },
            
                (data) => {
                    this.loading = false;
                    this.results = data.results;
                },
            
                () => {
                    this.loading = false;
                    this.$rc.alert('Error','Unable to search events');
                },
            );
        },

        onClickTechnicalData(item)
        {
            this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': item,
                });
        },

        onClickMessageParameters(item)
        {
                this.$rc.copy_code_dialog({
                    'title': 'Message Parameters',
                    'object': item,
                });
        },

        onClickEventDetails(item)
        {
            this.$refs['event-log-entries'].showDialog({
                'type': 'event',
                'event_id': item.event_id,
            });
        },

        onClickSecondGenerationShippingEvents()
        {
            this.type = ['shipping-new-tracking-number','shipping-first-in-transit','shipping-in-transit','out-for-delivery','delivery-attempt-failed','available-for-pickup','picked-up','delivered','exception','not-supported','shipping-expected-delivery-date-changed']; 
            this.doUpdate();
        },

        onClickOrders()
        {
            this.type = ['order-fulfilled-follow-up','order-placed']; 
            this.doUpdate();
        },

        onClickReservations()
        {
            this.type = this.$rc.enumChoices('event_type',true).filter(item => item.value.includes('reservation')).map(item => item.value); 
            this.doUpdate();
        }
    },

    computed: {
        title() {
            return 'Search '+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+' Reservations';
        },

        crm_name() {
            return this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name');
        }
    },
}
</script>

<style lang="scss" scoped>
.button_chip
{
    margin-top: 5px; 
    margin-bottom: 5px; 
    margin-right: 5px; 
    text-decoration: underline;
}
</style>